import { render, staticRenderFns } from "./Quarantine.vue?vue&type=template&id=572e8290"
import script from "./Quarantine.vue?vue&type=script&lang=js"
export * from "./Quarantine.vue?vue&type=script&lang=js"
import style0 from "./Quarantine.vue?vue&type=style&index=0&id=572e8290&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports